'use strict';
exports = module.exports = {
  test: {
    value: 'PASS'
  },
  global: {
    navbar: {
      HOME: 'Home',
      ADMIN: 'Admin',
      REPORT:'Report',
      MAP: 'Map',
      LOGOUT: 'Home',
      HELLO: 'Hi'
    }
  },
  calibration: {
    modal: {
      BACK_BUTTON: 'Back',
      NEXT: 'Next',
      CANCEL_LINK: 'Cancel Calibration',
      FINISH: 'Finish',
      STEP: 'Step',
      STEP_OF: 'of',
      clearCacheModal: {
        HEADING: 'Are You Sure?',
        MODAL_BODY: 'Are you sure you want to clear the cache? This action is permanent and cannot be undone.',
        CONFIRM_TEXT: 'Yes, delete the cache',
        DENY_TEXT: 'No, take me back'
      },
      stepOne :{
        HEADER: 'Screen Calibration Wizard',
        WELCOME_MESSAGE: 'Welcome to the <br><strong>Texas COLT - Jones Creek Simulations</strong>',
        LEAD_MESSAGE_ONE: 'This wizard will guide you through calibrating your screen for the best possible experience when viewing this site.',
        LEAD_MESSAGE_TWO: 'During calibration, we will ask you to hold a gift/loyalty card up against your monitor.',
        LEAD_MESSAGE_FOUR_STRONG: 'We do not capture, store or photograph any of your card details',
        LEAD_MESSAGE_FOUR: ', but use the size of the card to calibrate your screen, as it is a standard size across the world.'
      },
      stepTwo : {
        CALIBRATION: 'Screen Size',
        LEAD: 'Center your loyalty or gift card on the screen with the red dot in the middle, then drag the slider until the virtual card is the same size as your actual one.',
        SMALLER: 'Smaller',
        BIGGER: 'Bigger'
      },
      stepThree : {
        MONITOR_SIZE: 'YOUR MONITOR SIZE IS:',
        APPROX: 'APPROX.',
        CALIBRATION_COMPLETE: 'Screen Calibration Complete',
        YOUR_MONITOR_SIZE: 'Your monitor appears to be around',
        CALIBRATE_AGAIN_MESSAGE: '. If that does not seem right, press the back button to try calibration again. Otherwise, click finish to continue.',
        ARMS_LENGTH_MESSAGE: 'When using the Zoom mode of this tool later on, please view simulations at a distance of 50cm (approximately arm\'s length) from the screen.'
      }
    }
  },
  home: {
    HEADER: 'Projects',
    SUBTEXT: 'Our universal solar energy centers generate zero-emissions power for all FPL customers using the sun for fuel',
    SITES_FETCH_ERROR: 'There was an error fetching the sites from the database. Please try again later'
  },
  main: {
    sectors: {
      SOLAR: 'Solar',
      WIND: 'Wind',
      NUCLEAR: 'Nuclear',
      NATURAL_GAS: 'Natural Gas',
      FOSSILS: 'Fossils'
    },
    POPOVER_MESSAGE: 'Go to Site'
  },
  user: {
    settings: {
      CHANGE_PASSWORD_HEADER: 'Change Password',
      CURRENT_PASSWORD: 'Current Password',
      NEW_PASSWORD: 'New Password',
      INVALID_NEW_PASSWORD: 'Password must be at least 3 characters.',
      CONFIRM_NEW_PASSWORD: 'Confirm New Password',
      PASSWORD_MATCH: 'Passwords must match.',
      UPDATE_PWD_BUTTON: 'Update Password',
      DIFFERENT_MONITOR_USED: 'It looks like you\'re using a different monitor than before. For best results, please re-calibrate your display.',
      DANGER_ZONE: 'clear browsing data',
      CLEAR_CACHE: 'clear cache',
      CLEARED_CACHE: 'cached cleared',
      CHANGED_DISPLAY: 'changed display?',
      CALIBRATE_DISPLAY: 'Click Here To Calibrate Your Display'
    },
    login: {
      EMAIL: 'Email',
      PASSWORD: 'Password',
      ENTER_EMAIL_PASSWORD_MESSAGE: 'Please enter your email and password',
      INVALID_EMAIL_MESSAGE: 'Please enter a valid email.',
      LOGIN_BUTTON_MESSAGE: 'Login',
      POWERED_BY: 'Powered by '
    }
  },
  site: {
    banner: {
      slidermessage: {
        HIDE: 'click to hide',
        SHOW: 'click to show'
      },
      disclaimers: {
        TWO: 'Click on the view-cones to see simulations that show the Jones Creek Simulation.',
        ONE: 'Texas COLT - Jones Creek Simulations'
      }
    }
  },
  trueview: {
    BACK_PAGE:'Back to Previous Page',
    ZOOM_FACTOR: 'Zoom Factor',
    BEFORE_AFTER: 'Before/After',
    TRUEVIEW_MODE_BUTTON: 'Zoom',
    TRUEVIEW_MODE_SMALL: 'With TrueView&trade; Technology',

    fullscreen: {
      BEFORE: 'Before',
      AFTER: 'After',
      RESET_ZOOM: 'Reset Zoom',
      DISCLAIMER: 'DISCLAIMER: Zoom provides visual context by magnifying scenes beyond the capabilities of the human eye.  Zoomed images are not a true view of what a person would see.',
      EXIT_FULLSCREEN: 'Exit Zoom'
    }
  },
  admin: {
    SITES_HEADER: 'Sites',
    USERS_HEADER: 'Users',
    users: {
      HEADING: 'Users',
      BUTTON_NEW: 'Add New User'
    },
    sites: {
      HEADING: 'Site List',
      ADD_SITE_BUTTON: 'Add New Site',
      EMPTY: 'You don\'t have any sites yet.',
      create: {
        HEADING: 'Create Site',
        form: {
          NAME: 'Name',
          SLUG: 'Slug',
          DESCRIPTION: 'Description',
          LAT: 'Latitude',
          LNG: 'Longitude',
          BACKGROUND: 'Background Image',
          DROP_BOX: 'Drop/Click Here to Upload',
          SVG: 'SVG Image'
        },
        viewpoints: {
          HEADING: 'Viewpoints',
          ADD_VIEWPOINT_BUTTON: 'New Viewpoint',
          SUB_HEADING: 'List of Viewpoints',
          DISPLAY_TRUEVIEW_NUMBERS: 'Hide Trueviews Numbers'
        },
        buttons: {
          CANCEL: 'Cancel',
          SAVE: 'Save Site'
        }
      },
      edit: {
        HEADING: 'Edit Site',
        form: {
          NAME: 'Name',
          SLUG: 'Slug',
          DESCRIPTION: 'Description',
          LAT: 'Latitude',
          LNG: 'Longitude',
          DROP_BOX: 'Drop/Click Here to Upload',
          BACKGROUND: 'Background Image',
          SVG: 'SVG Image'
        },
        viewpoints: {
          HEADING: 'Viewpoints',
          ADD_VIEWPOINT_BUTTON: 'New Viewpoint',
          SUB_HEADING: 'List of Viewpoints',
          DISPLAY_TRUEVIEW_NUMBERS: 'Hide Trueviews Numbers'
        },
        buttons: {
          CANCEL: 'Cancel',
          UPDATE: 'Update Site'
        }
      },
      viewpointModal: {
        HEADING: 'Viewpoints',
        dropdown: {
          SELECT: 'Select a Viewpoint',
          TRUEVIEW: 'Trueview',
          VIDEO: 'Video'
        },
        form: {
          NAME: 'Viewpoint Name',
          DESCRIPTION: 'Description',
          BEFORE: 'Drop/Click Here To Upload Before Image',
          AFTER: 'Drop/Click Here To Upload After Image',
          VIDEO_ID: 'Wistia Hash Id',
          THUMBNAIL: 'Thumbnail'
        }
      }
    }
  },
  errorModal : {
    DISSMISS: 'Dismiss',
    SHOW_MORE_DETAILS: 'More Information'
  },
  progress: {
    UPLOADING_VIEWPOINT_ASSETS: 'Uploading viewpoint assets',
    UPLOADING_SITE_ASSETS: 'Uploading site assets',
    ALL_SAVED_SUCCESSFULLY: 'Site is saved successfully'
  },
  report: {
    HEADER: 'Report',
    WHO: 'Who',
    WHEN: 'When',
    WHAT_PAGE: 'What Page',
    WHAT_VIDEO: 'What Video',
    WHAT_TRUEVIEW: 'What Trueview',
    WHAT_SITE: 'What Site',
    SHOW_MORE: 'show more',
    NO_REPORT: 'There is nothing to report yet',
    NO_EVENT: 'No events to display',
    VISITED_URL: 'visited_url'
  }
}



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/lang/translate.en.js
// module id = 74
// module chunks = 0